// Text for one validation item ({ code, details? }) of an acceptance, shared by the side panel and
// the confirm dialog. Plain module with no Vue and no imports, so it runs under `node --test`.
//
//   validationLabel(item, { t, lines })
//     t      the i18n translate function ($t)
//     lines  dossier.checklist, to name the lines still to answer

function lineLabel(code, { t, lines }) {
  const line = (lines || []).find((l) => l.code === code);
  const key = `acceptance.checklist.lines.${code}`;
  const text = t(key);
  if (text !== key) return text;
  return line ? line.label : code;
}

export function validationLabel(item, { t, lines }) {
  const key = `acceptance.validation.codes.${item.code}`;
  if (item.code === "checklist_incomplete") {
    const codes = (item.details && item.details.codes) || [];
    return t(key, {
      count: codes.length,
      lines: codes.map((code) => lineLabel(code, { t, lines })).join(", "),
    });
  }
  const text = t(key);
  return text === key ? item.code : text;
}
